module.exports = __webpack_public_path__ + "static/media/sidebar.4a809e5b.png";